import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';

import { ProfitAndLossFieldName } from './LoanPL.constants';

const loanPLConfigFields = {
  [ProfitAndLossFieldName.NET_BUY_PRICE]: {
    fieldId: ProfitAndLossFieldName.NET_BUY_PRICE,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.NET_BUY_PRICE}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.SRP_PAID_OUT]: {
    fieldId: ProfitAndLossFieldName.SRP_PAID_OUT,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.SRP_PAID_OUT}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.HEDGE_COST]: {
    fieldId: ProfitAndLossFieldName.HEDGE_COST,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.HEDGE_COST}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.TOTAL_BUY_PRICE]: {
    fieldId: ProfitAndLossFieldName.TOTAL_BUY_PRICE,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.TOTAL_BUY_PRICE}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.NET_SELL_PRICE]: {
    fieldId: ProfitAndLossFieldName.NET_SELL_PRICE,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.NET_SELL_PRICE}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.SRP_FROM_INVESTOR]: {
    fieldId: ProfitAndLossFieldName.SRP_FROM_INVESTOR,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.SRP_FROM_INVESTOR}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.TOTAL_SELL_PRICE]: {
    fieldId: ProfitAndLossFieldName.TOTAL_SELL_PRICE,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.TOTAL_SELL_PRICE}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.PROFIT_LOSS_PERCENT]: {
    fieldId: ProfitAndLossFieldName.PROFIT_LOSS_PERCENT,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.PROFIT_LOSS_PERCENT}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
  [ProfitAndLossFieldName.PROFIT_LOSS_DOLLAR]: {
    fieldId: ProfitAndLossFieldName.PROFIT_LOSS_DOLLAR,
    type: FieldType.INPUT,
    nameInModel: `profitAndLoss.${ProfitAndLossFieldName.PROFIT_LOSS_DOLLAR}`,
    inputProps: {
      disabled: false,
      required: false,
      variant: 'outlined',
      type: FieldInputType.PERCENTAGE_RESTYLED,
      decimalScale: 3,
      decimalSeparator: '.',
      fixedDecimalScale: true,
      isNumericString: true,
    },
  },
};

export const loanPLDetailsConfig = {
  groups: [
    {
      type: FieldType.GROUP,
      fields: Object.values(loanPLConfigFields),
      key: 'loan-pl',
    },
  ],
};
